/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Summary_No_CycleInputs */



/**
* | output |
* | --- |
* | "{count} customer(s) have no billing cycle and will never be billed until it is fixed." |
*
* @param {Partner_Summary_No_CycleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_no_cycle = /** @type {((inputs: Partner_Summary_No_CycleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_No_CycleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Kunde(n) ohne Abrechnungszyklus – sie werden nie abgerechnet, bis das behoben ist.`)
	return /** @type {LocalizedString} */ (`${i?.count} customer(s) have no billing cycle and will never be billed until it is fixed.`)
});